export default __webpack_public_path__ + "static/media/congratsFastingLarge.37ce8471.svg";